import React from 'react';
import { Link } from 'react-router';
import { WithDeleteDialogZzFlatButton, ZzFlatButton, ZzSplitButton } from 'core/components/buttons/buttons';
import commonService from 'core/common/service/commonService';
import PageAncestor from 'core/common/page/pageAncestor';
import Toolmenu from 'core/components/toolmenu/toolmenu';
import { MdIconButton, ZzIconButtonMenu, ZzMenuItem } from 'core/components/buttons/icons';
import MenuItem from 'material-ui/MenuItem';
import mdEntityService from 'core/metamodel/mdEntityService';
import invoiceService, { invoiceItemGridLocation } from 'invoice/service/invoiceService';
import { ErrorComp } from 'core/components/errorComp/errorComp';
import Form from 'core/form/form';
import { formatValue, IDomainObject, lovLabel, lovValue, preSave, replaceIdWithLov } from 'core/form/formUtils';
import gridService from 'core/grid/gridService';
import GridComp, { UILOCATION } from 'core/grid/component/gridComp';
import Grid, { ClientGrid, GridLocation, GridRow } from 'core/grid/domain/grid';
import ConfirmationDialog from 'core/components/confirmationDialog/confirmationDialog';
import CustomerForm, { InvoiceCustomerBlock } from 'invoice/component/customerForm';
import InvoiceForm from 'invoice/component/invoiceForm';
import InvoiceItemForm from 'invoice/component/invoiceItemForm';
import { UNIT_OF_MEASURE } from 'product/productUtils';
import InvoiceSumTable from 'invoice/component/invoiceSumTable';
import InvoiceIssueDialog from 'invoice/component/invoiceIssueDialog';
import { BlockComp } from 'core/components/blockComp/blockComp';
import { Watermark } from 'core/components/common/watermark';
import DocumentComp from 'core/document/component/documentComp';
import { addTenantToQuery } from 'core/common/utils/utils';
import Add from 'material-ui/svg-icons/content/add';
import SvgMoreVert from 'material-ui/svg-icons/navigation/more-vert';
import { grey500 } from 'material-ui/styles/colors';
import Divider from 'material-ui/Divider';
import { addSeparatorBetweenArrays } from 'core/common/utils/arrayUtils';
import documentService from 'core/document/documentService';
import { MODULE, PageProps, PERMISSION, SECURABLE, SECURABLE_TYPE } from 'core/metamodel/metaConstant';
import 'invoice/page/invoiceDetail.less';
import { observer } from 'mobx-react';
import MdEntity, { LovItem } from 'core/metamodel/mdEntity';
import { DomainAncestor } from 'core/common/domain/DomainAncestor';
import {
  canDeleteInvoiceDocument,
  Invoice,
  INVOICE_TYPE,
  InvoiceGraph,
  InvoiceInInvoiceRelationType,
  InvoiceItem,
  INVOICEITEMTYPE,
  InvoiceRelation,
  INVOICESTATUS,
  relationArrayInverse
} from 'invoice/domain/invoiceDomain';
import { action, observable, ObservableMap } from 'mobx';
import { MovingBlocks } from 'core/grid/gridUtils';
import uiService from 'core/common/service/uiService';
import { EVENTTYPE, SENDTYPE } from 'core/event/eventDomain';
import {
  DOCUMENTATTACHMENTTYPE,
  DocumentPreviewDto,
  DOCUMENTSTATUS,
  nonReplacedDocumentFp
} from 'core/document/documentDomain';
import securityService from 'core/security/securityService';
import { InvoicePaymentComp } from 'invoice/component/invoicePayment';
import Tabs from 'material-ui/Tabs/Tabs';
import Tab from 'material-ui/Tabs/Tab';
import PropTypes from 'prop-types';
import { EmailAddressesEditorDialog, EmailAddressesEditorDialogReturnType } from 'core/event/component/emailComponents';
import { SelectableHolderWithPartyLov } from 'party/partyDomain';
import InvoiceAdvancedForm from 'invoice/component/invoiceAdvancedForm';
import { loc } from 'core/common/config/locales';
import { DynamicFieldsBlock } from '../../core/metamodel/dynamicFields';
import { formatDateIso } from '../../core/common/utils/dateUtils';
import pullAll = require('lodash/pullAll');
import MdReplyAll = require('react-icons/lib/md/reply-all');
import History from 'material-ui/svg-icons/action/history';
import {MenuItem as BsMenuItem} from "react-bootstrap";


interface BlockFieldDef {
  show: (dataObject: DomainAncestor) => boolean;
  value: (dataObject: DomainAncestor) => any;
  label: (dataObject: DomainAncestor) => string;
}


const InvoiceBlockTable = observer(({
                                      fieldList,
                                      entity,
                                      dataObject
                                    }: { fieldList: (string | BlockFieldDef)[], entity: MdEntity, dataObject: DomainAncestor }) => {
  const values: LovItem[] = fieldList.filter(v => (typeof v === 'string') ? (dataObject[v] != null) : v.show(dataObject))
    .map(v => {
      if (typeof v === 'string') {
        let mdField = entity.getField(v);
        return {value: formatValue(dataObject[v], mdField), label: mdField.formLabelActive};
      } else {
        return {value: v.value(dataObject), label: v.label(dataObject)};
      }
    });

  return (
    <table className="invoice-block-table">
      <tbody>
      {
        values.map((lov, index) => (
          <tr key={index}>
            <td>{lov.label}</td>
            <td>{lov.value}</td>
          </tr>
        ))
      }
      </tbody>
    </table>
  );
});

const CONCEPT_TABS = ["main", 'advanced', 'parameters'];
const ISSUED_TABS = ["detail", 'settlement'];


@observer
export default class InvoiceDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.invoicing;
  static title = 'Invoice';
  static icon = 'money';
  static protectedPage = true;

  static fetchData(routerParams, query) {
    console.log("InvoiceDetail#fetchData(%O)", query);

    let metadataPromise = mdEntityService.fetchEntityMetadata(['Invoice', 'InvoiceItem', 'InvoiceRole', 'InvoiceField', 'InvoiceRelation'],
      ['Document', {entity: 'ADDRESSTYPE', lov: true}, {entity: 'DOCUMENTATTACHMENTTYPE', lov: true}]);

    let invoicePromise: Promise<Invoice>;
    let toFinalInvoice: InvoiceInInvoiceRelationType;
    let toADInvoice: InvoiceInInvoiceRelationType;

    if (routerParams.id === 'new') {
      invoicePromise = invoiceService.issuedNew(query.paymentTypeId, query.partyId);
    } else if (routerParams.id === 'copy') {
      invoicePromise = invoiceService.readInvoice(query.copyId, {mode: 'copy'})
        .then((invoiceObject: Invoice) => {
          toFinalInvoice = query.linkToFI ? invoiceObject.createInvoiceInInvoiceRelation() : undefined;
          toADInvoice = query.linkToAD ? invoiceObject.createInvoiceInInvoiceRelation() : undefined;

          // copiedFromInvoiceId musi byt pred cleanOnCopy() jinak se vynuluje invoiceId !
          invoiceObject.copiedFromInvoiceId = invoiceObject.invoiceId;
          invoiceObject.cleanOnCopy();
          invoiceObject.invoiceId = undefined;
          invoiceObject.invoiceNumber = undefined;
          invoiceObject.invoiceType = undefined;
          invoiceObject.endInvoicePeriod = undefined;
          invoiceObject.startInvoicePeriod = undefined;
          invoiceObject.dueDate = undefined;
          invoiceObject.invoiceDate = undefined;
          invoiceObject.deliveryDate = undefined;
          invoiceObject.taxDate = undefined;
          invoiceObject.dateSentByPostToCustomer = undefined;
          invoiceObject.dateEmailedToCustomer = undefined;
          invoiceObject.dateSentToAccounting = undefined;
          invoiceObject.dateSentToTaxOffice = undefined;
          invoiceObject.dateSentToArchive = undefined;
          invoiceObject.taxOfficeConfirmationNumber = undefined;
          invoiceObject.taxOfficeConfirmationTime = undefined;
          invoiceObject.taxOfficeConfirmationError = undefined;

          invoiceObject.issueDate = undefined;
          invoiceObject.paidAmount = 0;
          invoiceObject.invoicePaid = undefined;
          invoiceObject.invoiceCredited = undefined;
          invoiceObject.entityNumberGen = undefined;
          invoiceObject.issuedBy = securityService.currentUser.getMePartyLov();

          invoiceObject.invoiceStatus = INVOICESTATUS.CONCEPT;
          invoiceObject.documents = [];
          invoiceObject.fromRels = [];
          invoiceObject.toRels = [];

          invoiceObject.items.forEach(t => {
            t.invoice = undefined;
            t.invoiceItemId = undefined;
          });

          return invoiceObject;
        });
    } else {
      invoicePromise = invoiceService.readInvoice(routerParams.id);
    }

    let gridPromise = gridService.fetchGrids(invoiceItemGridLocation);

    return Promise.all([metadataPromise, invoicePromise, gridPromise])
      .then(([entityMap, invoiceObject, gridLocationMap]: [ObservableMap<MdEntity>, Invoice, ObservableMap<GridLocation>]) => {
        invoiceObject.$new = !invoiceObject.invoiceId;

        if (!invoiceObject.invoiceType) invoiceObject.invoiceType = entityMap.get("InvoiceType").getLovItem(INVOICE_TYPE.FI);

        invoiceObject.$movingBlocks = new MovingBlocks(null, false, null,
          new ClientGrid<InvoiceItem>(gridLocationMap.get(invoiceItemGridLocation), "items", invoiceObject.invoiceId));

        invoiceObject.$headerTab = query.tab;

        invoiceService.invoiceObject = invoiceObject.initAfterRead(routerParams.id === 'new');

        if (toFinalInvoice) {
          invoiceObject.toRels.push(new InvoiceRelation({
            fromInvoice: toFinalInvoice,
            relationType: entityMap.get("INVOICERELATIONTYPE").getLovItem(relationArrayInverse( lovValue(toFinalInvoice.invoiceType), INVOICE_TYPE.FI)),
            valueDate: formatDateIso(new Date()),
            contributedAmount: toFinalInvoice.totalAdjustedPrice,
            currency: invoiceObject.invoiceCurrency
          }));
        } else if (toADInvoice) {
          invoiceObject.fromRels.push(new InvoiceRelation({
            toInvoice: toADInvoice,
            relationType: entityMap.get("INVOICERELATIONTYPE").getLovItem(relationArrayInverse( INVOICE_TYPE.AD, lovValue(toADInvoice.invoiceType))),
            valueDate: formatDateIso(new Date()),
            contributedAmount: toADInvoice.totalAdjustedPrice,
            currency: invoiceObject.invoiceCurrency
          }));
          invoiceObject.invoiceType = entityMap.get("InvoiceType").getLovItem(INVOICE_TYPE.AD);
        }
        if (toFinalInvoice || toADInvoice) {
          return invoiceService.recalculateWithClean(invoiceObject, {});
        }

      });
  }


  static contextTypes = {
    router: PropTypes.func.isRequired
  };

  private invoiceIssueDialogRef: InvoiceIssueDialog;
  private confirmationDialogRef: ConfirmationDialog;
  private emailAddressesEditorDialogRef: EmailAddressesEditorDialog;

  /**
   * tohle je tady kvuli prechodu na jiny detail invoice (chained details)
   * @param prevProps
   */
  componentDidUpdate(prevProps) {
    if (prevProps.params.id !== this.props.params.id) {
      this.onLoad();
    }
  }

  componentDidMount() {
    this.onLoad();
  }

  private onLoad() {
    invoiceService.invoiceObject.$movingBlocks.searchExposedGrids(invoiceService.invoiceObject);
    let tab = invoiceService.invoiceObject.$headerTab;
    if (tab && this[tab]) this[tab]();
  }

  componentWillUnmount() {
    invoiceService.invoiceObject = null;
  }

  customValidate = (invoiceObject: Invoice) => {
    let errors = [];

    return errors;
  };


  findRootObject() {
    return invoiceService.invoiceObject;
  }


  commitOpenItems(grid: Grid) {
    if (grid.data) {
      for (let row of grid.data.flatRows()) {
        let rowObject: InvoiceItem = row.rowObject as InvoiceItem;
        if (rowObject && rowObject.$added) {
          invoiceService.invoiceObject.items.push(rowObject);
        }
      }
    }
  }


  @action onSave = (evt) => {
    console.log('onSave invoiceId = %s, $new = %s', invoiceService.invoiceObject.invoiceId, invoiceService.invoiceObject.$new);


    // pridame do invoiceObject.items z otevrenych formu na gridu
    let grid = invoiceService.invoiceObject.$movingBlocks.getBlock(invoiceItemGridLocation) as ClientGrid<InvoiceItem>;
    this.commitOpenItems(grid);


    let result = preSave(invoiceService.invoiceObject, this.customValidate, true);
    if (!result) {
      return;
    }

    uiService.showToolbarActionFlag();
    invoiceService.invoiceSave(invoiceService.invoiceObject)
      .then(action("invoiceSave-action", (invoiceJson: IDomainObject) => {

        let wasNew = invoiceService.invoiceObject.cleanAfterSave(invoiceJson);

        if (wasNew) {
          this.context.router.replaceWith('invoiceDetail', {id: invoiceService.invoiceObject.invoiceId});
        }
        uiService.hideToolbarActionFlag();
      }), error => {
        invoiceService.invoiceObject.$errors = error.getMessages();
      });

  };


  @action onIssue = (invoiceTypeId: number, fastIssue: boolean, evt) => {
    console.log('onIssue invoiceType ' + invoiceTypeId + ", fastIssue = " + fastIssue);


    let grid = invoiceService.invoiceObject.$movingBlocks.getBlock(invoiceItemGridLocation) as ClientGrid<InvoiceItem>;

    // pridame do invoiceObject.items z otevrenych formu na gridu
    this.commitOpenItems(grid);

    let result = preSave(invoiceService.invoiceObject, this.customValidate, true);
    if (!result) {
      return;
    }

    new Promise((resolve, reject) => {
      this.invoiceIssueDialogRef.open(resolve, reject, invoiceTypeId, fastIssue);
    }).then((wasNew: boolean) => {
      grid.generateGridData(invoiceService.invoiceObject);
      uiService.hideToolbarActionFlag();

      if (wasNew) {
        this.context.router.replaceWith('invoiceDetail', {id: invoiceService.invoiceObject.invoiceId});
      }


      commonService.notifySuccess(lovLabel(invoiceService.invoiceObject.invoiceType) + ' was issued with number ' + invoiceService.invoiceObject.invoiceNumber);

    }).catch((e) => {
    })

  };


  onAdd = (evt) => {
    console.log('onAdd');
    let query = {paymentTypeId: 1};
    this.context.router.transitionTo("invoiceDetail", {id: 'new'}, query);
  };

  onCopy = (evt) => {
    console.log('onCopy');
    this.context.router.transitionTo("invoiceDetail", {id: 'copy'}, {copyId: invoiceService.invoiceObject.invoiceId});
  };

  @action onDelete = (evt) => {
    console.log('onDelete');

    invoiceService.deleteInvoice(invoiceService.invoiceObject.invoiceId)
      .then(response => {
        this.goBackOrHome();
      }, error => {
        invoiceService.invoiceObject.$errors = error.getMessages();
      });
  };


  @action onCancel = (evt) => {
    console.log('onCancel');

    new Promise((resolve, reject) => {
      this.confirmationDialogRef.open(resolve, reject, 'Do you really want to cancel this ' + lovLabel(invoiceService.invoiceObject.invoiceType) + ' ?');
    }).then(() => {
      console.log('do cancel');

      uiService.showToolbarActionFlag();

      invoiceService.cancelInvoice(invoiceService.invoiceObject)
        .then((invoiceJson: IDomainObject) => {
          invoiceService.invoiceObject.cleanAfterSave(invoiceJson);
          uiService.hideToolbarActionFlag();
        }, error => {
          invoiceService.invoiceObject.$errors = error.getMessages();
        });

    }).catch((e) => {
    })
  };

  @action onReopen = (evt) => {
    console.log('onReopen');

    new Promise((resolve, reject) => {
      this.confirmationDialogRef.open(resolve, reject, 'Do you really want to reopen this ' + lovLabel(invoiceService.invoiceObject.invoiceType) + ' ?');
    }).then(() => {
      console.log('do reopen');

      uiService.showToolbarActionFlag();

      invoiceService.reopenInvoice(invoiceService.invoiceObject)
        .then((invoiceJson: IDomainObject) => {
          invoiceService.invoiceObject.cleanAfterSave(invoiceJson);
          if (invoiceService.invoiceObject.tupleMap) {
            invoiceService.invoiceObject.tupleMap.hasEntityNumberGenDefault = null;
            invoiceService.invoiceObject.tupleMap.hasSeveralDefaultEntityNumberGen = null;
          }

          uiService.hideToolbarActionFlag();
        }, error => {
          invoiceService.invoiceObject.$errors = error.getMessages();
        });

    }).catch((e) => {
    })
  };

  @action handleSend = (evt) => {
    console.log('handleSend - ' + lovValue(invoiceService.invoiceObject.sendType));

    let sendType: string = lovValue(invoiceService.invoiceObject.sendType);


    if (sendType === SENDTYPE.EMAIL) {
      invoiceService.emailAddresses(invoiceService.invoiceObject)
        .then((emailAddresses: SelectableHolderWithPartyLov<string>[]) => {
          return new Promise((resolve, reject) => {
            this.emailAddressesEditorDialogRef.open(resolve, reject, observable({emails: emailAddresses}), invoiceService.invoiceObject.documents.some(d => lovValue(d.attachmentType) === DOCUMENTATTACHMENTTYPE.SEPARATE_INCLUDE), "Email Invoice")
          })
        })
        .then(action("sendEmails", (dto: EmailAddressesEditorDialogReturnType) => {
          uiService.showToolbarActionFlag();
          let {emails, insertSeparateDocsIntoMain} =  dto;
          console.log("Sending to emails: %o", emails);
          return invoiceService.sendInvoice(invoiceService.invoiceObject, false, insertSeparateDocsIntoMain, invoiceService.invoiceObject.invoiceStatus == INVOICESTATUS.CONCEPT ? EVENTTYPE.INVOICE_CONCEPT_SENT_EMAIL : undefined, emails);
        }))
        .then((res) => {
          uiService.hideToolbarActionFlag();
        })
        .catch((e) => {
        });

    } else if (sendType === SENDTYPE.POST) {

      new Promise((resolve, reject) => {
        this.confirmationDialogRef.open(resolve, reject, 'Do you really want to post this ' + lovLabel(invoiceService.invoiceObject.invoiceType) + ' ?');
      }).then(() => {
        const invoicePrintWindow = window.open("about:blank", 'invoicePrint');
        return invoiceService.sendInvoice(invoiceService.invoiceObject, false, false, undefined, undefined)
          .then((invoiceJson: IDomainObject) => {
            invoiceService.invoiceObject.cleanAfterSave(invoiceJson);
            let maxDocumentById = invoiceService.invoiceObject.documents.filter(doc => doc.status === DOCUMENTSTATUS.VALID)
              .reduce((prev, next) => (prev.documentId > next.documentId) ? prev : next );
            invoicePrintWindow.location.assign(documentService.documentUrl(maxDocumentById.documentUuid, {inline: true}));
          });
      }).catch((e) => {
      })

    }
  };


  @action previewInvoice = (evt) => {
    console.log('previewInvoice');
    uiService.showToolbarActionFlag();
    const invoicePreviewWindow = window.open("about:blank", 'invoicePreview');
    invoiceService.previewInvoice(invoiceService.invoiceObject)
      .then((documentPreviewDto: DocumentPreviewDto) => {
        uiService.hideToolbarActionFlag();
        invoicePreviewWindow.location.assign(documentService.documentTemporaryUrl(documentPreviewDto.id, {inline: true}));
      }, error => {
        invoiceService.invoiceObject.$errors = error.getMessages();
      });
  };


  @action handleMarkSent = (evt) => {
    return invoiceService.sendInvoice(invoiceService.invoiceObject, true, false, undefined, undefined)
      .then((res) => {
        invoiceService.invoiceObject.fromJson(res);
        commonService.notifyInfo('Invoice was marked as sent');
      });
  };


  @action addInvoiceItem = (itemType: string) => {
    console.log('addInvoiceItem %s', itemType);

    let grid = invoiceService.invoiceObject.$movingBlocks.getBlock(invoiceItemGridLocation) as ClientGrid<InvoiceItem>;

    let rowObject = new InvoiceItem({
      invoice: invoiceService.invoiceObject.invoiceLov(),
      adjustmentKoef: 0,
      adjustmentAmount: 0,

      $new: true,
      $dirty: true,
      $added: true,
      itemType: replaceIdWithLov(itemType, mdEntityService.getEntity('INVOICEITEMTYPE'))
    });

    if (itemType !== INVOICEITEMTYPE.FREEITEM) {
      rowObject.quantity = 1;
      rowObject.unitOfMeasure = replaceIdWithLov(UNIT_OF_MEASURE.pcs, mdEntityService.getEntity('UnitOfMeasure'));
    }

    grid.addRow(rowObject);
    let form: Form<InvoiceItem> = rowObject.getForm('InvoiceItemForm');
    form.$open = true;

    invoiceService.invoiceObject.$dirty = true;
  };


  @action addAllVehicles = () => {

    uiService.showToolbarActionFlag();

    return invoiceService.addAllVehicles(invoiceService.invoiceObject)
      .then((invoiceJson: IDomainObject) => {
        invoiceService.invoiceObject.cleanAfterSave(invoiceJson);
        invoiceService.invoiceObject.$dirty = true;
        uiService.hideToolbarActionFlag();
      }, error => {
        invoiceService.invoiceObject.$errors = error.getMessages();
      });

  };


  @action recalculateInvoice = (rootObject: Invoice, modifiedRows: GridRow[], toDeleteRows: GridRow[], params?: { [key: string]: any }): Promise<any> => {
    uiService.showToolbarActionFlag();

    if (modifiedRows) {
      for (let row of modifiedRows) {
        if (row.rowObject.$added) {
          invoiceService.invoiceObject.items.push(row.rowObject as any);
        }
      }
    }

    if (toDeleteRows) {
      pullAll(invoiceService.invoiceObject.items, toDeleteRows.map(row => row.rowObject));
    }

    return invoiceService.recalculateWithClean(invoiceService.invoiceObject, params)
      .then(action("recalculateWithClean-actionCb", () => {
        let grid = invoiceService.invoiceObject.$movingBlocks.getBlock(invoiceItemGridLocation) as Grid;
        grid.$dirty = true;
        invoiceService.invoiceObject.$dirty = true;
        uiService.hideToolbarActionFlag();
      }));

  };


  @action copyInvoiceItem = (invoiceItem: InvoiceItem): IDomainObject => {
    invoiceItem.invoiceItemId = undefined;
    invoiceItem.dateCreated = undefined;
    invoiceItem.dateUpdated = undefined;
    invoiceItem.userCreated = undefined;
    invoiceItem.tenantId = undefined;

    return invoiceItem;
  };


  disableEditDelete = (invoiceItem: InvoiceItem): boolean => {
    return (lovValue(invoiceItem.itemType) === INVOICEITEMTYPE.ROUNDINGDIFF);
  };

  @action handleChange = (tabName: string) => {
    this.tabChange(tabName, (tab) => {
      invoiceService.invoiceObject.$headerTab = tab;
    });
    this[tabName]();
  };

  @action detail() {
  }

  @action main() {
  }

  @action advanced() {
  }

  @action parameters() {
  }

  @action settlement() {
    return invoiceService.readInvoiceGraph(invoiceService.invoiceObject.invoiceId)
      .then(action("readInvoicePayments-handler", (invoiceGraph: InvoiceGraph) => {
        invoiceService.invoiceObject.$invoiceGraph = invoiceGraph;
      }));
  }

  @action saveFn(documents) {
    let invoiceObject = invoiceService.invoiceObject;

    if (invoiceObject.$new) {
      return Promise.resolve(null);
    } else {
      return Promise.all(documents.filter(doc => doc.$new).map(doc => documentService.saveDocument(doc, {invoiceId: (invoiceObject.invoiceId)})))
        .then(action("saveDocument-action", (documentJson: Array<IDomainObject>) => {
          console.log(documentJson.length);
          let newDocs = documents.filter(doc => doc.$new);
          for (let i = 0; i < documentJson.length; i++) {
            newDocs[i].cleanAfterSave(documentJson[i]);
          }
        }));
    }
  }


  invoiceIssueDialogRefHandler = comp => this.invoiceIssueDialogRef = comp;
  confirmationDialogRefHandler = comp => this.confirmationDialogRef = comp;
  emailAddressesEditorDialogRefHandler = comp => this.emailAddressesEditorDialogRef = comp;


  render() {

    const {
      query,
    } = this.props;

    let invoiceObject = invoiceService.invoiceObject;
    let invoiceEntity = mdEntityService.getEntity('Invoice');

    const propsForCreateForm = {
      dataObject: invoiceObject,
      rootObject: invoiceObject,
      entity: invoiceEntity,
      entities: mdEntityService.entityMap
    };

    let sendType: string = lovValue(invoiceObject.sendType);

    console.log('invoiceDetail render invoiceId = %s, $new = %s', invoiceObject.invoiceId, invoiceObject.$new);


    // InvoiceCustomerBlock, ktery potrebuje fields, se zpracuje drive nez se vytvori fields na CustomerForm
    let customerForm = invoiceObject.getForm("CustomerForm");
    let customerFormFields = customerForm.fields;
    if (!customerFormFields) {
      customerFormFields = customerForm.setupFields(invoiceObject, invoiceObject, invoiceEntity, mdEntityService.entityMap, null);
    }

    const selectedTabArray = (invoiceObject.invoiceStatus === INVOICESTATUS.CONCEPT) ? CONCEPT_TABS : ISSUED_TABS;
    const fixedTab = selectedTabArray.includes(invoiceObject.$headerTab) ? invoiceObject.$headerTab : selectedTabArray[0];

    const headerContent = (invoiceObject.invoiceStatus === INVOICESTATUS.CONCEPT) ? (

      <form>
        <div className="row">
          <div className="col-xs-12 col-sm-6" style={{marginTop: 20}}>
            <CustomerForm {...propsForCreateForm} recalculate={this.recalculateInvoice}/>
          </div>
          <div className="col-xs-12 col-sm-6">

            <Tabs value={fixedTab} onChange={this.handleChange}>
              <Tab label="Main" value="main">
                <InvoiceForm {...propsForCreateForm} recalculate={this.recalculateInvoice}/>
              </Tab>
              <Tab label="Advanced" value="advanced">
                <InvoiceAdvancedForm {...propsForCreateForm} recalculate={this.recalculateInvoice}/>
              </Tab>
              <Tab label="Parameters" value="parameters">
                <DynamicFieldsBlock dataObject={invoiceObject} rootObject={invoiceObject} entity={invoiceEntity} entities={mdEntityService.entityMap} />
              </Tab>
            </Tabs>

          </div>
        </div>
      </form>


    ) : (

      <div style={{position: 'relative'}}>
        <div style={{
          position: 'absolute',
          right: 5,
          top: 0
        }}>{lovValue(invoiceObject.language).toUpperCase() + ' ' + lovLabel(invoiceObject.sendType)}</div>

        <Tabs value={fixedTab} onChange={this.handleChange}>
          <Tab label="Details" value="detail">
            <BlockComp style={{marginTop: 10}}>

              <div className="row">
                <div className="cols-xs-12 col-sm-5">
                  <div className="invoice-block-header">The Customer</div>
                  <h5 className="form-header-text">
                    <Link to="partyDetail" params={{id: lovValue(invoiceObject.billedTo)}} query={addTenantToQuery()}>{invoiceObject.toFullName}</Link>
                  </h5>
                  <InvoiceCustomerBlock dataObject={invoiceObject} entities={mdEntityService.entityMap}
                                        entity={invoiceEntity}
                                        style={{display: 'flex', flexDirection: 'column', marginLeft: 10}}
                                        fields={customerFormFields} showLinkedInvoices={true}/>
                </div>

                <div className="cols-xs-12 col-sm-7" style={{marginBottom: 10}}>
                  <div className="invoice-block-header"><span className={invoiceObject.statusFontCss + ' zz-mr-5'}/>
                    <span>{`${lovLabel(invoiceObject.invoiceType)} # ${invoiceObject.invoiceNumber} on ${formatValue(invoiceObject.invoiceDate, invoiceEntity.getField('invoiceDate'))}`}</span>
                  </div>
                  <div style={{display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start'}}>
                    <InvoiceBlockTable key={1}
                                       fieldList={['taxDate', 'dueDate', 'deliveryDate', 'deliveryNoteDate', 'paymentType', 'orderDate', 'orderedBy']}
                                       entity={invoiceEntity} dataObject={invoiceObject}/>
                    <InvoiceBlockTable key={2}
                                       fieldList={['invoiceAdjustmentKoef', 'exchangeRate', 'profitCenter', 'orderNumber', 'deliveryNoteNumber', {
                                         show: (o) => o['startInvoicePeriod'] != null || o['endInvoicePeriod'] != null,
                                         value: (o) => formatValue(o['startInvoicePeriod'], invoiceEntity.getField("startInvoicePeriod")) + " - " + formatValue(o['endInvoicePeriod'], invoiceEntity.getField("endInvoicePeriod")),
                                         label: (o) => invoiceEntity.getField("startInvoicePeriod").formLabelActive
                                       }, 'issuedBy']}
                                       entity={invoiceEntity} dataObject={invoiceObject}/>

                    <InvoiceBlockTable key={3}
                                       fieldList={['accountingProfitCenter', 'costCenter', 'internalOrder', 'relatedInvoice', 'accountingMatchingId', 'accountingNumber']}
                                       entity={invoiceEntity} dataObject={invoiceObject}/>

                  </div>
                  {(invoiceObject.comment) ? (
                    <div style={{marginLeft: 10}}>{invoiceObject.comment}</div>
                  ) : null}
                  {(invoiceObject.internalComment) ? (
                    <div style={{marginLeft: 10}}>{invoiceObject.internalComment}</div>
                  ) : null}
                </div>
              </div>


            </BlockComp>
          </Tab>

          <Tab
            label="Settlements"
            value="settlement">
            <InvoicePaymentComp invoiceObject={invoiceObject}/>
          </Tab>

        </Tabs>
      </div>


    );


    const rowInvoiceItemForm = (
      <InvoiceItemForm rootObject={invoiceObject} entity={mdEntityService.getEntity('InvoiceItem')}
                       entities={mdEntityService.entityMap}
                       dataObject={null}/>
    );


    return (

      <main className="main-content" style={{display: 'flex', flexDirection: 'column'}}>
        {this._createToolMenu(invoiceObject, query.gridLocation)}
        {(invoiceObject.invoiceStatus === INVOICESTATUS.CANCELED) ? <Watermark text="Canceled"/> : null}
        <ErrorComp messages={invoiceObject.$errors}/>
        <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
        <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>
        {(invoiceObject.invoiceStatus === INVOICESTATUS.CONCEPT) ?
          <InvoiceIssueDialog ref={this.invoiceIssueDialogRefHandler} entities={mdEntityService.entityMap}/> : null}
        <ConfirmationDialog okButtonText="Yes" cancelButtonText="No" ref={this.confirmationDialogRefHandler}/>
        {(sendType === SENDTYPE.EMAIL) ?
          <EmailAddressesEditorDialog ref={this.emailAddressesEditorDialogRefHandler}/> : null}
        {headerContent}
        <div style={{display: 'flex', width: '100%', justifyContent: 'space-between', flexShrink: 0, flexWrap: 'wrap'}}>
          <DocumentComp documents={invoiceObject.documents} showFilterFn={nonReplacedDocumentFp}
                        entities={mdEntityService.entityMap} style={{flex: '1 1 auto', marginBottom: 10}}
                        enableUpload={invoiceObject.invoiceStatus === INVOICESTATUS.CONCEPT}
                        rootObject={invoiceObject} saveFn={this.saveFn}
                        documentEntity={mdEntityService.getEntity('Document')} canDeleteFn={canDeleteInvoiceDocument}
                        showIncludeCheckbox defaultAttachmentType={invoiceObject.billedTo?.defaultAttachmentType} />
          <InvoiceSumTable invoiceObject={invoiceObject} entities={mdEntityService.entityMap}
                           invoiceEntity={invoiceEntity}
                           style={{minWidth: '50%'}}/>
        </div>
        <GridComp ref={invoiceItemGridLocation}
                  grid={invoiceObject.$movingBlocks.getBlock(invoiceItemGridLocation) as Grid}
                  uiLocation={UILOCATION.main}
                  showEdit={invoiceObject.invoiceStatus === INVOICESTATUS.CONCEPT}
                  disableEditFn={this.disableEditDelete}
                  showDelete={invoiceObject.invoiceStatus === INVOICESTATUS.CONCEPT}
                  disableDeleteFn={this.disableEditDelete}
                  deleteRowIcon="fa fa-trash" rootObject={invoiceObject}
                  editForm={rowInvoiceItemForm} editFormName="InvoiceItemForm" entities={mdEntityService.entityMap}
                  editOverrideFn={this.recalculateInvoice} copyRowObjectFn={this.copyInvoiceItem}
                  multiUpdateSecurable={(invoiceObject.invoiceStatus === INVOICESTATUS.CONCEPT) ? SECURABLE.invoiceDetail : null}
                  multiUpdateSaveFn={this.onSave}>

          <ZzIconButtonMenu buttonIcon={<Add/>}
                            disabled={!invoiceObject.billedTo || !invoiceObject.invoiceCurrency || !invoiceObject.exchangeRate || invoiceObject.invoiceStatus !== INVOICESTATUS.CONCEPT}>
            <MenuItem primaryText="Free Item" onClick={this.addInvoiceItem.bind(this, INVOICEITEMTYPE.FREEITEM)}/>
            <MenuItem primaryText="Product" onClick={this.addInvoiceItem.bind(this, INVOICEITEMTYPE.PRODUCTITEM)}/>
            <MenuItem primaryText="Product & Vehicle"
                      onClick={this.addInvoiceItem.bind(this, INVOICEITEMTYPE.PRODUCTVEHICLEITEM)}/>
            <MenuItem primaryText="All Vehicles" onClick={this.addAllVehicles}/>
          </ZzIconButtonMenu>

        </GridComp>

      </main>


    );
  }


  _createToolMenu(invoiceObject: Invoice, gridLocation: string) {
    let _disableIssue = (invoiceObject.invoiceStatus !== INVOICESTATUS.CONCEPT || !invoiceObject.billedTo || !invoiceObject.items.length || !invoiceObject.invoiceType);

    let sendType = lovValue(invoiceObject.sendType);
    let invoiceTypeId = lovValue(invoiceObject.invoiceType);

    let sendMenuItemLabel = (sendType === SENDTYPE.EMAIL) ? "Email Invoice" : "Print Invoice";



    let menuArray = addSeparatorBetweenArrays(<Divider/>,
      (invoiceObject.invoiceStatus !== INVOICESTATUS.CONCEPT) ? null : [<ZzMenuItem primaryText="Email Concept" key={3} onClick={this.handleSend}/>,
      <ZzMenuItem primaryText="Preview Invoice" key={3} onClick={this.previewInvoice}/>],
      (invoiceObject.$new || invoiceObject.invoiceStatus !== INVOICESTATUS.ISSUED) ? null : [<ZzMenuItem
        primaryText="Cancel"
        key={3}
        securable={SECURABLE.cancelInvoice}
        onClick={this.onCancel}/>,
        <ZzMenuItem primaryText="Reopen" key={4} onClick={this.onReopen} securable={SECURABLE.reopenInvoice}/>,
        <ZzMenuItem primaryText={sendMenuItemLabel} key={5} onClick={this.handleSend}
                    securable={SECURABLE.sendInvoice}/>,
        (!invoiceObject.isSent()) ? <ZzMenuItem primaryText="Mark as Sent" key={4} onClick={this.handleMarkSent}
                                                securable={SECURABLE.sendInvoice}/> : null,
        (!!invoiceObject.invoiceId && securityService.hasRight(SECURABLE.documentTemplateDetail.name, PERMISSION.Read)) ?
          <a style={{paddingLeft: 20}} href={"/api/core/document/xml/Invoice/" + invoiceObject.invoiceId + "?inline=true"} className="mui-menu-item-link-1" target="_blank"> XML </a> : null
        ]
    );

    console.log(menuArray);

    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onBack} backDisabled={History.length <= 1} historize
                entityName="Invoice" entityId={invoiceObject.invoiceId}>
        <ZzFlatButton onClick={this.onSave}
                      disabled={!invoiceObject.$dirty}
                      label="Save" permission={invoiceObject.$new ? PERMISSION.New : PERMISSION.Update}/>
        <ZzFlatButton onClick={this.onAdd} disabled={invoiceObject.$new} label="New" permission={PERMISSION.New}/>
        <ZzFlatButton onClick={this.onCopy} disabled={invoiceObject.$new} label="Copy" permission={PERMISSION.New}/>
        <WithDeleteDialogZzFlatButton entityName="Invoice" pageAncestor={this} onClick={this.onDelete}
                      disabled={invoiceObject.$new || invoiceObject.invoiceStatus !== INVOICESTATUS.CONCEPT}
                      label="Delete" permission={PERMISSION.Delete}/>

        {
          !_disableIssue && securityService.hasRight(SECURABLE.issueInvoice.name, PERMISSION.Execute, invoiceTypeId + "") && (
            <ZzSplitButton bsStyle="toolbar" title={loc.i18n`Issue` + ' ' + lovLabel(invoiceObject.invoiceType)} onClick={this.onIssue.bind(this, invoiceTypeId, false)} id="issue-button">
              <BsMenuItem eventKey={0} onSelect={this.onIssue.bind(this, invoiceTypeId, false)}>Issue</BsMenuItem>
              <BsMenuItem eventKey={1} onSelect={this.onIssue.bind(this, invoiceTypeId, true)}>Issue immediatelly</BsMenuItem>
            </ZzSplitButton>
          )
        }

        <ZzIconButtonMenu buttonIcon={<SvgMoreVert/>} disabled={!menuArray.length}
                          securableType={SECURABLE_TYPE.DETAILACTION}>
          {menuArray}
        </ZzIconButtonMenu>


      </Toolmenu>
    );
  }


}




// WEBPACK FOOTER //
// ./src/invoice/page/invoiceDetail.tsx